module.exports = __webpack_public_path__ + "img/overworked-employee-dark.d566880f.svg";